// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"divide"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M16.5 12H7.5M12.0039 16.0039H12V16H12.0039V16.0039ZM12.0039 8.00391L12 8.00391V8L12.0039 8V8.00391Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const DivideIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'divide',
    ref,
    icon: element,
  },
));

DivideIcon.displayName = 'DivideIcon';

export default DivideIcon;
